export default {
  LOAD_LIST_AJUSTES(state, payload) {
    state.listAjustes = payload
  },
  RESET_AJUSTE(state) {
    state.ajuste = {
      id: '',
      obs: '',
      conta: null,
      data: null,
      valor: 0.0,
      tipo: 'CREDITO'
    }
  }
}
